<!--{{{ style -->
<style>
@import '../assets/app.css';
.edi-version {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #2c3e50;
	text-align: center;
	height: 100%;
	position: relative;
}
.edi-version form {
	width: 100%;
	padding-bottom: 20%;
}
.edi-version .fieldset-1 {
	margin-top: 6em !important;
}
.edi-version .fieldset-2 {
	margin-top: 1.175em;
}
.edi-version .logo {
	width: 126px;
	height: 126px;
}
.edi-version h4 {
	margin: .8em;
	font-size: 1.1em;
}
.edi-version h5 {
	font-size: 1em;
	margin: 0;
	font-weight: normal;
}
</style>
<!--}}}-->
<!--{{{ template -->
<template>
	<div class="edi-version" :style="{ 'height': deviceHeight }">
		<form @submit.prevent="onSubmit">
      <img class="logo" :src="store.sysInfo && store.sysInfo.logo || ''">
			<h4>{{store.sysInfo && store.sysInfo.name || '风行供货商EDI'}}</h4>
			<h5>v 1.0.0.0012</h5>
		</form>
	</div>
</template>
<!--}}}-->
<!--{{{ script -->
<script>
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			member: {
				mobile: '',
				password: ''
			},
			deviceHeight: this.$root.deviceHeight,
			store: GlobalStore
		}
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// Version.vue?a6f90932